<section class="page-control">
  <div class="flex justify-content-between w-full align-items-center">
    <h2>Nalozi IP</h2>
    <button
      class="main-btn"
      [routerLink]="['./add']"
      queryParamsHandling="merge"
    >
      Dodaj NIP <i class="pi pi-plus"></i>
    </button>
  </div>
</section>

<section class="page-control">
  <div class="grid w-full">
    <!-- FILTER FIELDS  -->
    <div class="col-12 sm:col-10">
      <form [formGroup]="form" class="grid">
        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Broj šarže</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="batch"
          />
        </div>

        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Broj zahteva</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="request_nr"
          />
        </div>

        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Ime proizvoda</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="product_name"
          />
        </div>

        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Kod proizvoda</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="product_code"
          />
        </div>

        <!-- <div class="col-6 sm:col-4">
          <label class="mb-2 block">Datum otvaranja</label>
          <p-calendar
            dateFormat="dd.mm.yy"
            class="filter-calendar"
            [showIcon]="true"
            formControlName="created_at"
          ></p-calendar>
        </div> -->

        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Rok izrade</label>
          <p-calendar
            dateFormat="dd.mm.yy"
            class="filter-calendar"
            [showIcon]="true"
            formControlName="deadline"
          ></p-calendar>
        </div>

        <div class="col-4">
          <label class="mb-2 block">Nalozi</label>
          <p-dropdown
            [options]="[
              {
                label: 'Svi nalozi',
                value: null
              },
              {
                label: 'Aktivni nalozi',
                value: false
              }
            ]"
            placeholder="Izaberi"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            formControlName="complete"
            class=""
          >
          </p-dropdown>
        </div>
      </form>
    </div>

    <!-- FILTER BUTTONS -->
    <div class="flex flex-column col-12 sm:col-2 align-items-end">
      <button class="main-btn w-10rem mt-4" (click)="onResetFilter()">
        Osveži <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>
</section>

<app-table
  [tableHeader]="fieldsService.tableHeader"
  [tableData]="nips.data"
  [loading]="loading"
  (handleDelete)="onDelete($event)"
  (handlePageChange)="onPageChange($event)"
  [paginator]="nips.pagination"
  [options]="{
    showEdit: true,
    showDelete: true
  }"
>
</app-table>
